export class TicketAssignAdminRequest {
    AdminID: number;
    TicketID: number;
}
